






























































import { defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api';
import Pagination from '@/components/Pagination';
import Box from '@/components/Box';
import DialogCom from '@/components/Dialog/index';
import Cloumns from '@/components/Cloumns/index.vue';
import request from '@/utils/request';
import DealAndPolicyDialog from '@components/dealAndPolicyDialog/index.vue';
import addComma from '@/utils/addComma';
import { Message } from 'element-ui';
import { userInfor as userInfoRef } from '@/useable/login';
import { encrypt } from '@/utils/aes';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'editThree',
  components: {
    Box,
    Pagination,
    DialogCom,
    Cloumns,
    DealAndPolicyDialog
  },
  setup(props: any, { root }) {
    const dialogReadTitle = '';
    const dialogReadType = '';
    const state: any = reactive({
      financeOrderApplyId: '',
      authCode: '',
      checked: false,
      calculator: false,
      dealVisible: false,
      policyVisible: false,
      workEmail: userInfor.workEmail,
      paymentOrderConfig: {
        column: [
          {key: 'custom', label: '序号', custom: true, align: 'center', width: 50},
          {key: 'payCorpName', label: '付款企业'},
          {key: 'supplierName', label: '收款企业'},
          {key: 'orderNo', label: '付款单号', width: 210},
          {key: 'amount', label: '付款金额', width: 130, custom: true, align: 'right', headerAlign: 'right'},
          {key: 'currency', label: '币种', width: 70},
          {key: 'orderTypeName', label: '付款单类型'},
          {key: 'orderStatusName', label: '付款单状态', width: 110},
          {key: 'planPayTime', label: '预计付款日期', width: 110},
        ],
        data: []
      },
      attrConfig: {
        column: [
          {key: 'custom', label: '序号', custom: true, width: 50},
          {key: 'fileName', label: '附件名称'},
          {key: 'fileSize', label: '附件大小', custom: true},
          {key: 'uploadTime', label: '上传日期'},
          {key: 'createBy', label: '上传人'},
          {key: 'c', label: '操作', operate: true}
        ],
        data: []
      },
      noteConfig: {
        column: [
          {key: 'custom', label: '序号', custom: true, width: 50},
          {key: 'commentCorpName', label: '备注方'},
          {key: 'commentPerson', label: '备注人'},
          {key: 'comment', label: '备注内容'},
          {key: 'commentTime', label: '备注时间'},
        ],
        data: []
      },
      basicInfo: [],
      text: '获取验证码',
      time: 60
    });
    const getData = async () => {
      const parms = {
        financeOrderApplyId: [...root.$route.params.id.split(',')]
      };
      const result = await request('financing', 'financingDetail', parms);
      if ( result.code === 2000 ) {
        const {data} = result;
        const financeOrderUndo = data.map(row=>row.financeOrderUndo);
        const financeOrderFile = data.map(row=>row.financeOrderFile);
        const financeOrderComment = data.map(row=>row.financeOrderComment);
        const financeOrderApply = data.map(row=>row.financeOrderApply);
        const [{ applyNo, supplierName, bankName, applyPersonName }] = financeOrderApply;
        const amount = financeOrderApply.map(row=>row.amount).reduce((a, b)=>a+b, 0);
        const applyAmount = financeOrderApply.map(row=>row.applyAmount).reduce((a, b)=>a+b, 0);
        const applyDays = Math.max(...financeOrderApply.map(row=>row.applyDays));
        state.basicInfo = [
          {title: '融资申请单号', value: data.length<2 ? applyNo : `${applyNo}等，共${data.length}单`},
          {title: '融资企业名称', value: supplierName},
          {title: '可融资金额', value: `${addComma(amount)} CNY`},
          {title: '本次融资金额', value: `${addComma(applyAmount)} CNY` },
          {title: '融资银行', value: bankName},
          {title: '融资天数', value: parms.financeOrderApplyId.length<=1 ? `${applyDays}天` : '各付款单最大可融资天数'},
          {title: '申请人', value: applyPersonName},
        ];
        state.financeOrderApply = financeOrderApply;
        state.paymentOrderConfig.data = financeOrderUndo;
        state.attrConfig.data = financeOrderFile || [];
        state.noteConfig.data = financeOrderComment;
        // }
      }
    };

    const goBack = () => {
      root.$router.push({
        path: '/Financing/edit/editTwo',
        query: {
          financeOrderApplyId: state.financeOrderApply.map(row=>row.financeOrderApplyId).join(',')
        }
      });
    };
    const refer = () => {
      if (state.checked) {
        state.calculator = true;
      } else {
        Message.error('请先阅读并同意用户协议和隐私政策');
      }
    };

    const closeDialog = () => {
      state.calculator = false;
      state.authCode = '';
    };
    const getCellPhone = async () => {
      if ( state.time === 60 ) {
        const parms = {
          type: 'financing',
          workEmail: encrypt(state.workEmail)
        };
        const result = await request('financing', 'sendCheckCode', parms);
        if (result.code === 2000) {
          countDown();
        }
      }
    };
    const countDown = () => {
      const interval = setInterval(()=>{
        if ( state.time<= 0 ) {
          state.time = 60;
          state.text = '重新获取验证码';
          window.clearInterval(interval);
        } else {
          state.time = state.time-1;
          state.text = `请${state.time}秒后重新发送验证码`;
        }
      }, 1000);
    };

    const saveOrSubmit = async (type) => {
      const parms = 
      state.financeOrderApply.map((row)=>{
        return {
          ...row,
          authCode: state.authCode,
          applyStatus: 1,
          buttonType: type,
        };
      });
      console.log('saveOrSubmit', parms);
      const result = await request('financing', 'financingSave', parms);
      if ( result.code === 2000) {
        if (type === 'save') {
          Message.success('保存成功');
        } else {
          if (result.data === '5') {
            root.$alert('该单已临近到期日并进入付款流程，无法进行融资', '操作提示', {
              confirmButtonText: '确定',
              center: true,
            });
          } else {
            root.$alert('融资申请已提交成功，请在收到通知邮件（或融资单据状态变为“待确认”）后，通过单据详情跳转银行侧进行融资申请确认。', '操作提示', {
              confirmButtonText: '确定',
              center: true,
              callback: () => {
                const url = state.financeOrderApply[0]?.redirectUrl;
                console.log(state.financeOrderApply);
                if (url) window.open(url);
              }
            });
          }
        }
        root.$router.push({
          path: '/Financing/search',
        });
      }
    };

    // 下载附件
    const downFile = async (row) => {
      const parms = {
        financeOrderFileId: row.financeOrderFileId
      };
      await request('financing', 'financingFileDownload', parms);
    };

    onMounted(getData);

    return {
      ...toRefs(state),
      goBack,
      refer,
      saveOrSubmit,
      closeDialog,
      getCellPhone,
      downFile,
      addComma,
      dialogReadTitle,
      dialogReadType
    };
  },
});
